module.exports = __webpack_public_path__ + "img/1510979387.badc8f37.jpg";